import React, { FC, SVGProps } from 'react'

interface Frame1330Props extends SVGProps<SVGSVGElement> {
	image: string
	rotate: number
	isEmpty: boolean
	flipped?: boolean
}

const FRAME_WIDTH = 604.78
const FRAME_HEIGHT = 823.05
const SCREEN_X = 15.02
const SCREEN_Y = 15.01
const SCREEN_WIDTH = 574.74
const SCREEN_HEIGHT = 766.36

const ScreenBacking: FC<{ transform?: string; fill: string }> = ({
	transform,
	fill,
}) => (
	<path
		transform={transform}
		fill={fill}
		d="M16.94,15.01h570.9c1.06,0,1.92.86,1.92,1.92v762.52c0,1.06-.86,1.92-1.92,1.92H16.94c-1.06,0-1.92-.86-1.92-1.92V16.93c0-1.06.86-1.92,1.92-1.92Z"
	/>
)

const Bezel: FC<{ transform?: string }> = ({ transform }) => (
	<g transform={transform}>
		<path
			fill="#231f20"
			d="M604.28,819.71V3.33c0-1.57-1.27-2.83-2.83-2.83H3.33C1.77.5.5,1.77.5,3.33v816.38c0,1.57,1.27,2.83,2.83,2.83h598.11c1.57,0,2.83-1.27,2.83-2.83ZM16.94,780.95c-.78,0-1.42-.63-1.42-1.42V17.02c0-.78.63-1.42,1.42-1.42h570.9c.78,0,1.42.63,1.42,1.42v762.52c0,.78-.63,1.42-1.42,1.42H16.94Z"
		/>
		<path
			fill="#979797"
			d="M601.45,823.05H3.33c-1.84,0-3.33-1.5-3.33-3.33V3.33C0,1.5,1.5,0,3.33,0h598.11c1.84,0,3.33,1.5,3.33,3.33v816.38c0,1.84-1.5,3.33-3.33,3.33ZM3.33,1C2.05,1,1,2.05,1,3.33v816.38c0,1.29,1.05,2.33,2.33,2.33h598.11c1.29,0,2.33-1.05,2.33-2.33V3.33c0-1.29-1.05-2.33-2.33-2.33H3.33Z"
		/>
	</g>
)

const Frame1330: FC<Frame1330Props> = ({ image, rotate, isEmpty, flipped }) => {
	const screenFill = isEmpty ? '#fff' : '#231f20'
	if (rotate == 0) {
		const width = FRAME_HEIGHT
		const height = FRAME_WIDTH
		const screenWidth = SCREEN_HEIGHT
		const screenHeight = SCREEN_WIDTH
		const screenX = flipped ? width - SCREEN_Y - SCREEN_HEIGHT : SCREEN_Y
		const screenY = FRAME_WIDTH - SCREEN_X - SCREEN_WIDTH
		const frameTransform = [
			flipped && `rotate(180, ${width / 2}, ${height / 2})`,
			`translate(0, ${FRAME_WIDTH}) rotate(-90)`,
		]
			.filter(Boolean)
			.join(' ')

		return (
			<svg
				viewBox={`0 0 ${width} ${height}`}
				width={`${width}px`}
				height={`${height}px`}
			>
				<ScreenBacking transform={frameTransform} fill={screenFill} />
				{isEmpty ? (
					<image
						width={screenWidth}
						height={screenHeight}
						xlinkHref={image}
						x={screenX}
						y={screenY}
						preserveAspectRatio="none"
					/>
				) : (
					<g transform={`translate(${screenX}, ${screenY})`}>
						<image
							width={screenHeight}
							height={screenWidth}
							xlinkHref={image}
							transform={`translate(0, ${screenHeight}) rotate(-90)`}
							preserveAspectRatio="none"
						/>
					</g>
				)}
				<Bezel transform={frameTransform} />
			</svg>
		)
	}

	const screenY = flipped ? FRAME_HEIGHT - SCREEN_Y - SCREEN_HEIGHT : SCREEN_Y
	const centerX = SCREEN_X + SCREEN_WIDTH / 2
	const centerY = screenY + SCREEN_HEIGHT / 2
	const frameTransform = flipped
		? `rotate(180, ${FRAME_WIDTH / 2}, ${FRAME_HEIGHT / 2})`
		: undefined

	return (
		<svg
			viewBox={`0 0 ${FRAME_WIDTH} ${FRAME_HEIGHT}`}
			width={`${FRAME_WIDTH}px`}
			height={`${FRAME_HEIGHT}px`}
		>
			<ScreenBacking transform={frameTransform} fill={screenFill} />
			{isEmpty ? (
				<image
					width={SCREEN_HEIGHT}
					height={SCREEN_WIDTH}
					xlinkHref={image}
					x={centerX - SCREEN_HEIGHT / 2}
					y={centerY - SCREEN_WIDTH / 2}
					transform={`rotate(-90, ${centerX}, ${centerY})`}
					preserveAspectRatio="none"
				/>
			) : (
				<image
					width={SCREEN_WIDTH}
					height={SCREEN_HEIGHT}
					xlinkHref={image}
					x={SCREEN_X}
					y={screenY}
					preserveAspectRatio="none"
				/>
			)}
			<Bezel transform={frameTransform} />
		</svg>
	)
}

export default Frame1330
